import { css } from "@emotion/react";

import { colors, timing, animations } from "@styles";

export const boxLink = css`
  padding: 0.75rem;
  margin-bottom: 0.5rem;

  &:active {
    .icon-right {
      margin-left: 2rem;
    }
  }
`;

export const stethoscope = css`
  margin-right: 1rem;
  color: ${colors.info};
`;

export const arrowIcon = css`
  margin-left: 1rem;
  color: ${colors.primary};
  transition: margin ${timing.fast} ${animations.easeOutCubic};
`;
